import { Col, Container, Row } from "reactstrap";

const Scholarship = () => {
  return (
    <section className="section" id="scholarship">
      <Container>
        <Row className="">
          <Col xs='12' lg='5'>
          <img
            src="assets/images/scholarship.webp" 
            alt="students-apply-for-scholarship-illustration"
            className="img-fluid" 
            loading="lazy" 
          />
          </Col>
          <Col xs='12' lg='7'>
            <h1 className="mt-3 mt-lg-0 mb-3">Info Beasiswa</h1>
            <div>
              <h2><b>WA Regional TAFE Bursary - AUD $5,000</b></h2>
              <p>
                Dapat AUD $5,000 untuk kamu yang memilih kampus di regional 
                WA sambil belajar dan hidup di Australia. Cocok banget buat 
                bantu biaya hidup, akomodasi, buku, dll.                
              </p>
            </div>  
            <p className="note">*Syarat berlaku, misalnya visa pelajar, tinggal di kampus regional, dan minimal durasi studi tertentu.</p>         
          </Col>          
        </Row>
      </Container>
    </section>
  );
};

export default Scholarship;